module.exports = __webpack_public_path__ + "03_bob_black.e7994352.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_bob_black.png
// module id = x6nL
// module chunks = 0